import {toast} from 'react-toastify'
import {getDate, Message} from '../../../_metronic/helpers'
import {setup} from '../../../api/SetupAPI'

export const handleSubmit = (
  InputField: {
    name: string
    address: string
    country: string
    state: string
    city: string
    pincode: string
    website: string
    weekStartDay: string
    weekendDays: string[]
    financialYearStartDate: string
    financialYearEndDate: string
    firstName: string
    lastName: string
    email: string
    password: string
    mobile: string
    inTime: string
    outTime: string
  },

  initialState: {
    name: string
    address: string
    country: string
    state: string
    city: string
    pincode: string
    website: string
    weekStartDay: string
    weekendDays: string[]
    financialYearStartDate: string
    financialYearEndDate: string
    firstName: string
    lastName: string
    email: string
    password: string
    mobile: string
    inTime: string
    outTime: string
  },
  setInputField: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  setActive: Function
) => {
  let {cnt, error} = validateForm(InputField, 2)
  setInputError(error)

  if (cnt === 0) {
    setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
    setup(InputField).then((res) => {
      if (res.statusCode === 201) {
        toast.success(res.message)
        setInputField(initialState)
        setInputError({})
        setActive(0)
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      } else {
        Message(res.message, 'error')
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      }
    })
  }
}
export const validateForm = (
  formField: {
    name: string
    address: string
    country: string
    state: string
    city: string
    pincode: string
    website: string
    weekStartDay: string
    weekendDays: string[]
    financialYearStartDate: string
    financialYearEndDate: string
    firstName: string
    lastName: string
    email: string
    password: string
    mobile: string
    inTime: string
    outTime: string
  },
  active: number
) => {
  let cnt = 0
  const error: any = {}
  const {formattedDate} = getDate()

  if (active == 1) {
    if (!formField.financialYearStartDate) {
      cnt = cnt + 1
      error.financialYearStartDate = 'Year Start Date should not be blank/invalid'
    } else if (formField.financialYearStartDate) {
      let newDate = formField.financialYearStartDate.split('-')
      if (newDate[0].length > 4) {
        cnt = cnt + 1
        error.financialYearStartDate = 'Year is invalid'
      }
    }

    if (!formField.financialYearEndDate) {
      cnt = cnt + 1
      error.financialYearEndDate = 'Year End Date should not be blank/invalid'
    } else if (formField.financialYearEndDate) {
      let newDate = formField.financialYearEndDate.split('-')
      if (newDate[0].length > 4) {
        cnt = cnt + 1
        error.financialYearEndDate = 'Year is invalid'
      } else if (formField.financialYearEndDate < formattedDate) {
        cnt = cnt + 1
        error.financialYearEndDate = 'Year End Date should not be less than current date'
      }
    }

    if (formField.weekendDays?.length === 0) {
      cnt = cnt + 1
      error.weekendDays = 'Please select/enter a Weekends.'
    }

    if (!formField.weekStartDay) {
      cnt = cnt + 1
      error.weekStartDay = 'Please select/enter a Week Start Day.'
    }
  } else if (active == 2) {
    if (!formField.inTime.trim()) {
      cnt = cnt + 1
      error.inTime = 'Please enter/select an In Time.'
    }
    if (!formField.outTime.trim()) {
      cnt = cnt + 1
      error.outTime = 'Please enter/select an Out Time.'
    }

    const baseDate = new Date()

    const [inHours, inMinutes] = formField.inTime.split(':')
    const [outHours, outMinutes] = formField.outTime.split(':')

    const inTime = new Date(baseDate)
    inTime.setHours(parseInt(inHours, 10), parseInt(inMinutes, 10), 0, 0)

    const outTime = new Date(baseDate)
    outTime.setHours(parseInt(outHours, 10), parseInt(outMinutes, 10), 0, 0)

    // Check if out time is earlier than in time and adjust for the next day
    if (outTime.getTime() < inTime.getTime()) {
      outTime.setDate(outTime.getDate() + 1)
    }

    const timeDifferenceInMilliseconds = outTime.getTime() - inTime.getTime()
    const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60)


    if (timeDifferenceInHours > 10) {
      cnt = cnt + 1
      error.outTime =
        "Please ensure that the 'Out Time' does not exceed 10 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
    } else if (timeDifferenceInHours < 4) {
      cnt = cnt + 1
      error.outTime =
        "Please ensure that the 'Out Time' must be at least 4 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
    }

    if (!formField.firstName) {
      cnt = cnt + 1
      error.firstName = 'Please enter a First Name.'
    } else {
      // First Name must be at least 2 characters.
      if (formField.firstName.length < 2) {
        cnt = cnt + 1
        error.firstName = 'First Name must be at least 2 characters.'
      }

      if (formField.firstName.length > 35) {
        cnt = cnt + 1
        error.firstName = 'First Name must not exceed 35 characters.'
      }

      const nameRegex = /^[a-zA-Z]+$/
      if (!nameRegex.test(formField.firstName)) {
        cnt = cnt + 1
        error.firstName = 'Please enter a valid First Name using only alphabetic characters.'
      }
    }

    if (!formField.lastName) {
      cnt = cnt + 1
      error.lastName = 'Please enter a Last Name.'
    } else {
      if (formField.lastName.length < 2) {
        cnt = cnt + 1
        error.lastName = 'Last Name must be at least 2 characters.'
      }

      if (formField.lastName.length > 35) {
        cnt = cnt + 1
        error.lastName = 'Last Name must not exceed 35 characters.'
      }

      const nameRegex = /^[a-zA-Z]+$/
      if (!nameRegex.test(formField.lastName)) {
        cnt = cnt + 1
        error.lastName = 'Please enter a valid Last Name using only alphabetic characters.'
      }
    }

    if (!formField.email) {
      cnt = cnt + 1
      error.email = 'Please enter a Email.'
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const doubleDotRegex = /\.\./
      if (!emailRegex.test(formField.email) || doubleDotRegex.test(formField.email)) {
        cnt = cnt + 1
        error.email = 'Please enter a valid email.'
      }
    }

    if (!formField.mobile) {
      cnt = cnt + 1
      error.mobile = 'Please enter a Mobile No.'
    } else if (!/^\d+$/.test(formField.mobile)) {
      cnt = cnt + 1
      error.mobile = 'Please enter a valid Mobile Number using only numeric characters.'
    } else if (formField.mobile.length !== 10) {
      cnt = cnt + 1
      error.mobile = 'Mobile Number must be exactly 10 digits.'
    }

    if (!formField.password.trim()) {
      cnt = cnt + 1
      error.password = 'Please enter a Password'
    } else {
      // Password must be at least 8 characters.
      if (formField.password.length < 8) {
        cnt = cnt + 1
        error.password = 'Password must be at least 8 characters.'
      }

      // Password must not exceed 16 characters.
      if (formField.password.length > 16) {
        cnt = cnt + 1
        error.password = 'Password must not exceed 16 characters.'
      }

      // Password must contain at least one uppercase letter.
      const uppercaseRegex = /[A-Z]/
      if (!uppercaseRegex.test(formField.password)) {
        cnt = cnt + 1
        error.password = 'Password must contain at least one uppercase letter.'
      }

      // Password must contain at least one lowercase letter.
      const lowercaseRegex = /[a-z]/
      if (!lowercaseRegex.test(formField.password)) {
        cnt = cnt + 1
        error.password = 'Password must contain at least one lowercase letter.'
      }

      // Password must contain at least one number.
      const numberRegex = /\d/
      if (!numberRegex.test(formField.password)) {
        cnt = cnt + 1
        error.password = 'Password must contain at least one number.'
      }

      // Password must contain at least one special symbol.
      const specialSymbolRegex = /[!@#$%^&*(),.?":{}|<>]/
      if (!specialSymbolRegex.test(formField.password)) {
        cnt = cnt + 1
        error.password = 'Password must contain at least one special symbol.'
      }
    }
  } else {
    if (!formField.name) {
      cnt = cnt + 1
      error.name = 'Please enter a Company Name.'
    } else {
      if (formField.name.length < 2) {
        cnt = cnt + 1
        error.name = 'Company Name must be at least 2 characters.'
      }

      if (formField.name.length > 50) {
        cnt = cnt + 1
        error.name = 'Company Name must not exceed 50 characters.'
      }

      const cNameRegex = /^[a-zA-Z0-9\s.]+[^\W_]*$/
      if (!cNameRegex.test(formField.name)) {
        cnt = cnt + 1
        error.name =
          'Please enter a valid Company Name using only alphanumeric characters with spaces and special characters.'
      }
    }
    if (!formField.address) {
      cnt = cnt + 1
      error.address = 'Please enter a Address.'
    }
    if (!formField.country) {
      cnt = cnt + 1
      error.country = 'Please enter a Country.'
    } else if (!/^[a-zA-Z]+$/.test(formField.country)) {
      cnt = cnt + 1
      error.country = 'Please enter a valid Country Name using only alphabetic characters.'
    } else if (formField.country.length < 2) {
      cnt = cnt + 1
      error.country = 'Country Name must be at least 2 characters.'
    } else if (formField.country.length > 50) {
      cnt = cnt + 1
      error.country = 'Country Name must not exceed 50 characters.'
    }

    if (!formField.state) {
      cnt = cnt + 1
      error.state = 'Please enter a State.'
    } else if (!/^[a-zA-Z]+$/.test(formField.state)) {
      cnt = cnt + 1
      error.state = 'Please enter a valid State Name using only alphabetic characters.'
    } else if (formField.state.length < 2) {
      cnt = cnt + 1
      error.state = 'State Name must be at least 2 characters.'
    } else if (formField.state.length > 50) {
      cnt = cnt + 1
      error.state = 'State Name must not exceed 50 characters.'
    }
    if (!formField.city) {
      cnt = cnt + 1
      error.city = 'Please enter a City.'
    } else if (!/^[a-zA-Z]+$/.test(formField.city)) {
      cnt = cnt + 1
      error.city = 'Please enter a valid City Name using only alphabetic characters.'
    } else if (formField.city.length < 2) {
      cnt = cnt + 1
      error.city = 'City Name must be at least 2 characters.'
    } else if (formField.city.length > 50) {
      cnt = cnt + 1
      error.city = 'City Name must not exceed 50 characters.'
    }

    if (!formField.pincode) {
      cnt = cnt + 1
      error.pincode = 'Please enter a Pin Code.'
    } else if (!/^\d+$/.test(formField.pincode)) {
      cnt = cnt + 1
      error.pincode = 'Please enter a valid Pin Code using only numeric characters.'
    } else if (formField.pincode.length !== 6) {
      cnt = cnt + 1
      error.pincode = 'Pin Code must be exactly 6 digits.'
    }

    if (!formField.website) {
      cnt = cnt + 1
      error.website = 'Please enter a Website.'
    }
  }
  return {error, cnt}
}
